import type { JSX } from 'react'

import React, { useContext } from 'react'
import { ChannelProgramRowSC } from '../ProgramList.styled'
import { ChannelProgramRowContext } from './ChannelProgramList'

export interface IChannelProgramRow {
  children: React.ReactNode | React.ReactNode[]
  selected?: boolean
}

export const ChannelProgramRow = ({
  children,
  selected,
}: IChannelProgramRow): JSX.Element => {
  const rowContext = useContext(ChannelProgramRowContext)

  return (
    <ChannelProgramRowSC>
      {React.Children.map(children, (child, index) => {
        // First child is TVCardEPG and it doesn't need props, because they start rendering image that causes flickering
        return React.isValidElement(child)
          ? React.cloneElement(child as React.ReactElement<any>, {
              ...(index > 0 && rowContext),
              selected,
            })
          : null
      })}
    </ChannelProgramRowSC>
  )
}
